module.exports = __webpack_public_path__ + "src/app/_content/imgs/endOfTerm/link.png?dc46096ab13cbadf68399d0b7bf3cd36";